import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-secure-eft-transaction-version-two',
  templateUrl: './secure-eft-transaction.component.html',
  styleUrls: ['./secure-eft-transaction.component.scss']
})
export class SecureEftTransactionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
